
import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { showVacancyText, showGreenFont, showOrangeFont, showGrayFont, showPinkFont } from "@/usecase/vacancy";
import qticket from "@/usecase/qticket";

export default Vue.extend({
  name: "component-vacancy-request-button",
  components: {
    QtButton: () => import("@/components/qt-button.vue"),
    MaterialIcons: () => import("./material-icons.vue"),
    VacancyCountText: () => import("@/components/common/vacancy-count-text.vue"),
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: (value: string) => {
        return ["primary", "outlined", "text", "danger"].includes(value);
      },
    },
    vacancyStatus: {
      type: Object as PropType<PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined>,
      required: false,
      default: undefined,
      validator: (value) => {
        return value !== null && value !== undefined;
      },
    },
    isShowVacancyText: { type: Boolean, default: true },
    showUpdateDate: { type: Boolean, default: false },
    isDesktop: { type: Boolean, default: false },
    qticketUrl: {
      type: String,
      required: false,
    },
    showKaisetuLink: { type: Boolean, default: false },
    isFlexEnd: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters("data", ["getLanguageWithoutCountry"]),
    isShowCountText(): boolean {
      return !this.vacancyStatus ? false : this.vacancyStatus.isShowCountText;
    },
    updateDate(): string {
      return this.vacancyStatus?.lastUpdateDate ?? "";
    },
    showQtButton(): boolean {
      return qticket.showQtButton(this?.qticketUrl);
    },
    disableQtButtonStatus(): boolean {
      return (
        qticket.disableQtButtonStatus(this.vacancyStatus?.qticketStatus) || this.vacancyStatus?.status === "closed"
      );
    },
    isEnglish(): boolean {
      return this.getLanguageWithoutCountry === "en";
    },
    showVacancyText(): string {
      if (this.vacancyStatus === undefined) return "";
      return showVacancyText(this.vacancyStatus);
    },
    calcVacancyTextLength(): boolean {
      return this.showVacancyText.length >= 13;
    },
    showGreenFont(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return showGreenFont(this.vacancyStatus);
    },
    showOrangeFont(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return showOrangeFont(this.vacancyStatus);
    },
    showGrayFont(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return showGrayFont(this.vacancyStatus);
    },
    showPinkFont(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return showPinkFont(this.vacancyStatus);
    },
    isEntryRestricted(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return this.vacancyStatus.status === "entryRestricted";
    },
  },
  methods: {
    openQticketUrl() {
      if (this.disableQtButtonStatus) return;
      window.open(this?.qticketUrl);
    },

    notReadyClicked() {
      this.$emit("not-ready-clicked");
    },
  },
});
